import PrivateRoute from 'components/privateRoute/PrivateRoute';

export default PrivateRoute;
